import React from 'react';
import PropTypes from 'prop-types';
import { publish, subscribe, unsubscribe } from '@wh/message-bus';
import { IconAsset, Drawer, DrawerItem, AdditionalNavItem } from '@sitebase/web-shell-kit';
import { ODDS_FORMAT_CHANGE_TOPIC } from '../../topics';
import { ODDS_RENDERER_TYPE } from '../../rendererTypes';

class OddsMenu extends React.Component {
  state = {
    oddsFormat: '',
    currentOddsIcon: '',
  };

  componentDidMount() {
    this.subscribeId = subscribe(ODDS_FORMAT_CHANGE_TOPIC, this.changeOddsFormat);
  }

  componentWillUnmount() {
    if (this.subscribeId) {
      unsubscribe(this.subscribeId);
    }
  }

  onClick = (id) => () => {
    publish(ODDS_FORMAT_CHANGE_TOPIC, id);
  };

  findCurrentOddsIcon = (oddsFormat) => {
    const currentOddsItem = this.props.items.find((child) => child.data.id === oddsFormat);

    return currentOddsItem ? currentOddsItem.data.icon : '';
  };

  changeOddsFormat = (_, oddsFormat) => {
    if (this.state.oddsFormat !== oddsFormat) {
      this.setState({
        oddsFormat,
        currentOddsIcon: this.props.isNested ? this.findCurrentOddsIcon(oddsFormat) : '',
      });
    }
  };

  render() {
    const oddsDropdownContent = (
      <Drawer data-test-id={`${ODDS_RENDERER_TYPE}.dropdown_${this.props.id}`}>
        {this.props.items &&
          this.props.items.map((child) => {
            const { id, icon, label } = child.data;
            const key = `odds_child_${id}`;
            return (
              <DrawerItem
                id={id}
                data-test-id={`${ODDS_RENDERER_TYPE}.item_${id}`}
                icon={icon ? <IconAsset name={icon} /> : undefined}
                active={this.state.oddsFormat === id}
                key={key}
                onClick={this.onClick(id)}
              >
                {label}
              </DrawerItem>
            );
          })}
      </Drawer>
    );

    const itemSharedProps = {
      'data-test-id': `${ODDS_RENDERER_TYPE}_${this.props.id}`,
      id: this.props.id,
    };

    if (this.props.isNested) {
      const { currentOddsIcon } = this.state;

      return (
        <DrawerItem {...itemSharedProps} icon={currentOddsIcon ? <IconAsset name={currentOddsIcon} /> : undefined}>
          {this.props.label}
          {oddsDropdownContent}
        </DrawerItem>
      );
    }

    return (
      <AdditionalNavItem {...itemSharedProps} label={this.props.label}>
        {oddsDropdownContent}
      </AdditionalNavItem>
    );
  }
}

OddsMenu.defaultProps = {
  isNested: false,
};

OddsMenu.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  isNested: PropTypes.bool,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      data: PropTypes.shape({
        id: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        icon: PropTypes.string.isRequired,
      }),
    })
  ),
};

const renderFunction = ({ data }) => <OddsMenu key={data.id} {...data} />;

const buildOddsMenuRenderer = () => ({
  type: ODDS_RENDERER_TYPE,
  render: renderFunction,
  schema: {},
});

const OddsMenuRenderer = buildOddsMenuRenderer();

export default OddsMenuRenderer;
